import React from 'react'
import './styles.css'
import {
  defineMessages,
  FormattedMessage
} from 'react-intl'
import Modal from 'components/Modal'
import Button from 'components/Button'
import { SUPPORTED_BROWSERS, BROWSER_METADATA } from 'constants/supportedBrowsers'
import chromeLogo from 'images/chromeLogo.png'
import edgeLogo from 'images/edgeLogo.png'
import firefoxLogo from 'images/firefoxLogo.png'
import safariLogo from 'images/safariLogo.png'
import { each, find } from 'lodash'

const messages = defineMessages({
  unsupportedBrowser: 'You are using an unsupported web browser.',
  unsupportedVersion: 'You are using an unsupported version of this browser',
  close: 'Close',
  install: 'Install',
  pleaseDownload: "Please download one of the following",
  pleaseUpdate: "Please update your current browser"
})

const LOGOS = {
  chrome: chromeLogo,
  firefox: firefoxLogo,
  edge: edgeLogo,
  safari: safariLogo
}

function browserOption (supported) {
  return (
    <div data-testid='browser-option' styleName='browser-box' key={supported}>
      <img styleName='browser-icon' src={LOGOS[supported]} />
      <div data-testid='vendor-name' styleName='browser-text'>
        <strong>
          {`${BROWSER_METADATA[supported].vendor} ${BROWSER_METADATA[supported].browser}`}
        </strong>
        <br/>
      </div>
      { BROWSER_METADATA[supported].installURL && (
        <a
          data-testid='install-link'
          onClick={() => window.open(BROWSER_METADATA[supported].installURL)}
          styleName='install-link'
        >
          <FormattedMessage {...messages.install} />
        </a>
      )}
    </div>
  )
}

function InvalidBrowserModal(props) {
  const {
    os,
    currBrowser,
    isValidBrowser,
    show,
    closeModal,
  } = props
  let browsers = []

  if (!os) return null
  const currBrowserNameIsSupported = find(Object.keys(SUPPORTED_BROWSERS[os] || {}), supported => {
    return currBrowser.indexOf(supported) >= 0
  })
  const currBrowserOutdated = currBrowserNameIsSupported && !isValidBrowser

  if (!currBrowserOutdated) {
    each(Object.keys(SUPPORTED_BROWSERS[os] || {}), supported => {
      browsers.push(browserOption(supported))
    })
  }

  const titleMsg = currBrowserOutdated ? messages.unsupportedVersion : messages.unsupportedBrowser
  const bodyMsg = currBrowserOutdated ? messages.pleaseUpdate : messages.pleaseDownload

  return (
    <Modal
      title={(<FormattedMessage {...titleMsg} />)}
      show={show}
      footer={(
        <Button
          type='ok'
          onClick={() => {
            closeModal()
          }}
        >
          <FormattedMessage {...messages.close} />
        </Button>
      )}
    >
      <div styleName='body'>
        <h3 data-testid='body-header'><FormattedMessage {...bodyMsg} /></h3>
        {browsers}
      </div>
    </Modal>
  )
}

export default InvalidBrowserModal
